import { AnchorAsButton } from '@packages/ui/base/button/anchor_as_button';

export interface UnknownErrorPageProps {
  title?: string;
  message?: string;
}

export const UnknownErrorPage = ({
  title = 'Sorry something went wrong.',
  message = 'We are going to investigate this issue.',
}: UnknownErrorPageProps) => {
  return (
    <div className="bg-primary-gradient text-primary-foreground flex h-screen flex-col items-center justify-center px-4">
      <div className="text-center">
        <h2 className="text-3xl font-bold">{title}</h2>
        <p className="mx-auto mt-4 mb-12 max-w-xs">{message}</p>

        <AnchorAsButton href="/">
          <span>Go to homepage</span>
        </AnchorAsButton>
      </div>
    </div>
  );
};
